import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule, NavController } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { MyApp } from './app.component';
import { ComponentsModule } from '../components/components.module';
import { LoginPage } from '../pages/login/login';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LogoComponent } from '../components/logo/logo';
import { TimesheetlistPage } from '../pages/timesheetlist/timesheetlist';
import { Tab1Page } from '../pages/tab1/tab1';
import { Tab2Page } from '../pages/tab2/tab2';
import { FilterPage } from '../pages/filter/filter';
import { HttpModule } from '@angular/http';
import { GlobalProvider } from '../providers/global/global';
import { APIInterceptor } from '../app/APIInterceptor';
import { PopoverPage } from '../pages/popover/popover';
import { ConfirmPage } from '../pages/confirm/confirm';
import { ThankYouPage } from '../pages/thank-you/thank-you';
import { TimesheetType3Page } from '../pages/timesheet-type3/timesheet-type3';
import { Timesheet3Component } from '../components/timesheet3/timesheet3';
import { Timesheet1Component } from '../components/timesheet1/timesheet1';
import { ChangePasswordPage } from '../pages/change-password/change-password';
import { ForgotPasswordPage } from '../pages/forgot-password/forgot-password';
import { Ionic2RatingModule } from 'ionic2-rating';
import { ConfirmType1Page } from '../pages/confirm-type1/confirm-type1';
import { ConfirmType1MonthlyPage } from '../pages/confirm-type1-monthly/confirm-type1-monthly';
import { ExpensePopUpPage } from '../pages/expense-pop-up/expense-pop-up';
import { ExpensesPage } from '../pages/expenses/expenses';
import { Camera } from '@ionic-native/camera';
import { RequestsProvider } from '../providers/requests/requests';

import { MymodalComponent } from '../components/mymodal/mymodal';
// import { ImagePicker } from '@ionic-native/image-picker';
import { Keyboard } from '@ionic-native/keyboard';
import { RejectPage } from '../pages/reject/reject';
import { SafeHtmlPipe } from '../pipes/safe-html/safe-html';

import { AddRateManualPopupPage } from '../pages/add-rate-manual-popup/add-rate-manual-popup';

class CameraMock extends Camera {
  getPicture(options) {
    return new Promise((resolve, reject) => {
      resolve("BASE_64_ENCODED_DATA_GOES_HERE");
    })
  }
}

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    TimesheetlistPage,
    LogoComponent,
    Tab1Page,
    Tab2Page,
    FilterPage,
    PopoverPage,
    TimesheetType3Page,
    ConfirmPage,
    ThankYouPage,
    Timesheet3Component,
    Timesheet1Component,
    ChangePasswordPage,
    ConfirmType1Page,
    ConfirmType1MonthlyPage,
    ExpensesPage,
    MymodalComponent,
    RejectPage,
    ForgotPasswordPage,
    ExpensePopUpPage,
    SafeHtmlPipe,
    AddRateManualPopupPage

  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    ComponentsModule,
    HttpClientModule,
    HttpModule,
    Ionic2RatingModule

  ],
  bootstrap: [IonicApp,],
  entryComponents: [
    MyApp,
    LoginPage,
    TimesheetlistPage,
    LogoComponent,
    Tab1Page,
    Tab2Page,
    FilterPage,
    PopoverPage,
    TimesheetType3Page,
    ConfirmPage,
    ThankYouPage,
    Timesheet3Component,
    Timesheet1Component,
    ChangePasswordPage,
    ConfirmType1Page,
    ConfirmType1MonthlyPage,
    ExpensesPage,
    MymodalComponent,
    RejectPage,
    ForgotPasswordPage,
    ExpensePopUpPage,
    AddRateManualPopupPage

  ],
  providers: [
    StatusBar,
    Camera,
    ExpensesPage,
    Keyboard,
    // NavController,
    // ImagePicker,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    //{ provide: Camera, useClass: CameraMock },
    GlobalProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: APIInterceptor,
      multi: true,
    },
    RequestsProvider
  ],

  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],

  exports:[Timesheet3Component]

})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts